import styled, { css } from 'styled-components';

import { isUiPatternRadio } from 'state/menu/types';

import { IPickerAspectOptionContainer } from './types';

const PickerAspectOptionContainer = styled.label<IPickerAspectOptionContainer>`
  background-color: ${Styles.color.white};
  border: 0;
  border-bottom: 1px solid ${Styles.color.grey.four};
  color: ${p => (p.disabled ? Styles.color.grey.three : Styles.color.black)};
  display: flex;
  font-size: 0.9375rem;
  justify-content: space-between;
  line-height: 1.75rem;
  margin: 0 0 0 0;
  outline: ${Styles.color.tertiary};
  padding: 0.5rem 0.5rem;
  position: relative;
  text-align: left;

  &:not([disabled]):hover {
    cursor: pointer;
  }

  ${p =>
    !isUiPatternRadio(p) &&
    css`
      &:last-child {
        border-bottom: none;
      }

      &:not([disabled]):hover {
        transition: background-color 0.3s;
        background-color: ${Styles.color.grey.five};
      }
    `}

  ${Styles.desktop`
    font-size: 0.9375rem;
  `}

  ${p =>
    isUiPatternRadio(p) &&
    css`
      display: flex;
      position: relative;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      text-align: center;
      border: 1px solid ${Styles.color.grey.five};
      border-radius: 0;
      border-right: none;
      padding: 0.25rem 0rem;
      margin-bottom: 0;

      &:last-of-type {
        border-right: 1px solid ${Styles.color.grey.five};
      }

      ${Styles.desktop`
        padding: 1rem 1.25rem;
      `}
    `}

  ${p =>
    isUiPatternRadio(p) &&
    p.selected &&
    css`
      color: ${Styles.color.white};
      background-color: ${Styles.color.primary};
      border: none;
    `}
`;

export default PickerAspectOptionContainer;
